import * as React from "react";
import { BpoHeader } from "@duosoftbg/bpo-components";

const Header = () => {
  return <BpoHeader subHeaderTitle={""} showMonitoring={false} />;
};
export default Header;
